import React from "react";

const TgridHowtoPosts = () => {
  return (
    <div>
      <div>
        Turn on use templegrid posts
        <div> use the templegrid panel</div>
        <div> from the panel copy and paste embedded tweet</div>
        <div> charge $5 a month</div>
      </div>
      <div>
        TempleGrid Post item
        <div>
          <div>470 characters</div>
          10 photos
        </div>
        <div>upgrade 600</div>
      </div>
    </div>
  );
};

export default TgridHowtoPosts;
